import { breakpoints } from '@rocheglobal/component-library-dot-com/src/style/base';
import React, { useEffect, useRef, useState } from 'react';
import { ExternalDataService } from '../../services/external-data';
import { PipelineDiagnostics } from '../../services/external-data/types';

const getPipelineDiagnostics = async (): Promise<PipelineDiagnostics[]> => {
  const response = await ExternalDataService.getPipelineDiagnostics();
  return response.Items;
};

export const RochePipelineDiagnostics = (): JSX.Element => {
  const containerRef = useRef<HTMLDivElement>(null);
  const [content, setContent] = useState<PipelineDiagnostics[]>([]);
  const [isMobile, setIsMobile] = useState(false);

  const getClientWidth = () => (typeof document !== 'undefined' ? document.body.clientWidth : null);
  const checkIsMobile = () => getClientWidth() < breakpoints.large;

  useEffect(() => {
    const handleResize = () => setIsMobile(checkIsMobile());

    window.addEventListener('resize', handleResize);
    handleResize();

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      if (!containerRef.current) {
        return;
      }

      try {
        const diagnosticsData = await getPipelineDiagnostics();
        setContent(diagnosticsData);
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error('Error fetching pipeline diagnostics data:', error);
      }
    };

    fetchData();
  }, []);

  return (
    <div ref={containerRef}>
      <roche-pipeline-diagnostics content={JSON.stringify(content)} is-mobile={isMobile}></roche-pipeline-diagnostics>
    </div>
  );
};
